import { cn } from "@/lib/utils";

export type InvoiceStatusCode =
  | "Draft"
  | "Sent"
  | "PartPaid"
  | "Paid"
  | "OverPaid"
  | "Overdue"
  | "Cancelled";

// Tones use raw Tailwind palette colours because StatusBadge does not provide
// a `purple` token and we need bespoke `line-through` styling for `Cancelled`.
// Mirrors the colour mapping from invoices-and-payments-plan-i.md Task 28.
const styles: Record<InvoiceStatusCode, string> = {
  Draft:     "bg-sky-100 text-sky-800",
  Sent:      "bg-blue-100 text-blue-800",
  PartPaid:  "bg-amber-100 text-amber-800",
  Paid:      "bg-green-100 text-green-800",
  OverPaid:  "bg-purple-100 text-purple-800",
  Overdue:   "bg-destructive/15 text-destructive",
  Cancelled: "bg-secondary text-muted-foreground line-through",
};

const labels: Record<InvoiceStatusCode, string> = {
  Draft:     "Draft",
  Sent:      "Sent",
  PartPaid:  "Part paid",
  Paid:      "Paid",
  OverPaid:  "Over paid",
  Overdue:   "Overdue",
  Cancelled: "Cancelled",
};

export function InvoiceStatusBadge({ code }: { code: InvoiceStatusCode }) {
  return (
    <span
      className={cn(
        "inline-block rounded px-2 py-0.5 text-xs font-medium",
        styles[code],
      )}
    >
      {labels[code]}
    </span>
  );
}
